var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.906937 0 0 0.884501 0 1.95052V13.6537C0 14.7197 0.906937 15.6042 2 15.6042H18C19.0931 15.6042 20 14.7197 20 13.6537V1.95052C20 0.884501 19.0931 0 18 0H2ZM2 1.95052H18V13.6537H2V1.95052ZM8 3.90105C7.73478 3.90105 7.48043 4.0038 7.29289 4.18669C7.10536 4.36959 7 4.61765 7 4.87631C7 5.13496 7.10536 5.38303 7.29289 5.56592C7.48043 5.74882 7.73478 5.85157 8 5.85157C8.26522 5.85157 8.51957 5.74882 8.70711 5.56592C8.89464 5.38303 9 5.13496 9 4.87631C9 4.61765 8.89464 4.36959 8.70711 4.18669C8.51957 4.0038 8.26522 3.90105 8 3.90105ZM12.5 6.82683L9 10.7279L6.5 8.28972L3.77734 11.7031H16.25L12.5 6.82683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorImage);
export default __webpack_public_path__ + "static/media/icon_editor_image.3409f4eba796553541af4f7a1c59bec2.svg";
export { ForwardRef as ReactComponent };